<template>
  <div class="subsidyDetails">
    <van-sticky>
      <div
        class="subsidyDetailsNav"
        :style="{ 'padding-top': (isiOSX ? 44 : 24) + 'px' }"
      >
        <img
          class="navLeft"
          @click="goBack()"
          src="./../../../assets/decoration/back.png"
        />
        <span class="navTitle">本期详情</span>
      </div>
    </van-sticky>
    <div class="content">
      <div class="cardTop">
        <p>第{{ data.number }}期</p>
        <h3>¥{{ data.subsidy_amount }}</h3>
        <span>{{ data.status_name }}</span>
      </div>
      <div class="card">
        <h3>本期信息</h3>
        <div class="item">
          <p>订单编号：</p>
          <span>
            {{ data.order_sn }}
            <img
              @click="copy()"
              id="copycode"
              :data-clipboard-text="data.order_sn"
              src="./../../../assets/decoration/copy.png"
              alt=""
          /></span>
        </div>
        <div class="item">
          <p>账户类型：</p>
          <span>{{ data.type_name }}</span>
        </div>
        <div class="item" v-if="data.status == 1">
          <p>预计补贴时间：</p>
          <span>{{ data.subsidy_at }}</span>
        </div>
        <div class="item" v-if="data.status == 2">
          <p>补贴时间：</p>
          <span>{{ data.subsidy_finished_at }}</span>
        </div>
        <div class="item" v-if="data.status == 3">
          <p>预计退订时间：</p>
          <span>{{ data.subsidy_at }}</span>
        </div>
        <div class="item" v-if="data.status == 4">
          <p>退订时间：</p>
          <span>{{ data.subsidy_finished_at }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Clipboard from "clipboard";
export default {
  data() {
    return {
      isiOSX: false,
      subsidy_id: null,
      data: {},
    };
  },
  created() {
    this.isiOSX = this.isIphoneX();
    this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
    if (this.$route.query.subsidy_id) {
      this.subsidy_id = this.$route.query.subsidy_id;
    }
    this.getData();
  },
  mounted() {},
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    // 获取详情
    getData() {
      this.$api
        .post("decoration/member/order/subsidy/show", {
          subsidy_id: this.subsidy_id,
        })
        .then((res) => {
          // console.log(res);
          this.data = res;
        });
    },
    copy() {
      var clipboard = new Clipboard("#copycode");
      clipboard.on("success", (e) => {
        this.$toast("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        this.$toast("复制失败");
        // 释放内存
        clipboard.destroy();
      });
    },
  },
};
</script>
<style lang="less">
.subsidyDetails {
  height: 100%;
  background: #f5f6ff;
  .subsidyDetailsNav {
    background: #ffffff;
    height: 44px;
    position: relative;
    .navLeft {
      width: 24px;
      height: 24px;
      position: absolute;
      left: 16px;
      bottom: 10px;
    }
    .navTitle {
      position: absolute;
      left: 50%;
      bottom: 10px;
      transform: translateX(-50%);
      font-size: 17px;
      font-weight: 700;
      color: #404247;
    }
  }
  .content {
    margin: 0 16px;
    .cardTop {
      background: #ffffff;
      border-radius: 12px;
      margin: 12px 0;
      padding: 24px;
      color: #333333;
      font-size: 14px;
      line-height: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      p {
        color: #999999;
        font-size: 14px;
      }
      h3 {
        font-size: 24px;
        line-height: 33px;
        margin: 16px 0;
      }
    }
    .card {
      background: #ffffff;
      border-radius: 12px;
      padding: 24px;
      h3 {
        font-size: 15px;
        color: #333333;
        line-height: 21px;
        margin: 0 0 4px;
      }
      .item {
        display: flex;
        align-items: center;
        margin-top: 16px;
        font-size: 15px;
        color: #333333;
        line-height: 21px;
        p {
          color: #999999;
        }
        span {
          display: flex;
          align-items: center;
          img {
            width: 16px;
            height: 16px;
            margin-left: 6px;
          }
        }
      }
    }
  }
}
</style>